/* eslint-disable no-underscore-dangle */
import SearchClient from '../search';

export default class ContactsClient extends SearchClient {
  constructor(options = {}) {
    super(options);
  }

  getContacts = async (data) => {
    try {
      const response = await this.request('get')(
        { data },
        { path: 'tablas/contactos' },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }

  async deleteDevice(data) {
    try {
      const response = await this.request('delete')(
        { data },
        { path: `contactos/${data.id}/dispositivos` },
      );
      return response.data;
    } catch (error) {
      return error.response;
    }
  }
}
